import { Component } from 'react'
import { connect } from 'react-redux'
import CoordinateRange from './CoordinateRange'
import { Toggle } from '../../../cdl-react-components/components'
import { setConfiguration } from '../../../../store/actions'
import { graphqlFetch } from '../../../cdl-react-components/utilities'
 
class LocationSearch extends Component {
    DLS = 'dls'
    NTS = 'nts'

    initialState = (val = '') => ({
        displayed: this.DLS,
        dls: {
            type: 'dls',
            townshipStart: val,
            townshipEnd: val,
            rangeStart: val,
            rangeEnd: val,
            meridianStart: val,
            meridianEnd: val,
        },
        nts: {
            type: 'nts',
            blockStart: val,
            blockEnd: val,
            subdivisionStart: val,
            subdivisionEnd: val,
            mapUnitStart: val,
            mapUnitEnd: val,
            quadStart: val,
            quadEnd: val,
        }
    })
    state = this.initialState()

    getLocationValue = () => this.state[this.state.displayed]

    hasValue = () => {
        const location = this.getLocationValue()
        return location && 
            ((location.type === 'dls' &&
             (location.townshipStart ||
              location.townshipEnd ||
              location.rangeStart ||
              location.rangeEnd || 
              location.meridianStart ||
              location.meridianEnd)) ||
            (location.type === 'nts' &&
             (location.blockStart ||
              location.blockEnd ||
              location.subdivisionStart ||
              location.subdivisionEnd ||
              location.mapUnitStart ||
              location.mapUnitEnd ||
              location.quadStart ||
              location.quadEnd)))
    }

    parseSearchParamsToState = (params, callback) => {
        if (params) {
            const pullValue = name => {
                const item = params.find(x => x.name === name)
                if (item && typeof item.value === 'string')
                    item.value = item.value.split(',').map(x => x.trim())                                     

                return item ? item.value : undefined
            }

            let township = pullValue('township')
            let range = pullValue('range')
            let meridian = pullValue('meridian')

            let block = pullValue('block')
            let subdivision = pullValue('subdivision')
            let mapUnit = pullValue('mapUnit')
            let quad = pullValue('quad')

            let displayed = undefined;
            let dls = undefined;
            let nts = undefined;
            if (block || subdivision || mapUnit || quad) {
                // nts
                block = block || ["", ""]
                subdivision = subdivision || ["", ""]
                mapUnit = mapUnit || ["", ""]
                quad = quad || ["", ""]

                nts = {
                    type: this.NTS,
                    blockStart: block[0] || "",
                    blockEnd: block[1] || "",
                    subdivisionStart: subdivision[0] || "",
                    subdivisionEnd: subdivision[1] || "",
                    mapUnitStart: mapUnit[0] || "",
                    mapUnitEnd: mapUnit[1] || "",
                    quadStart: quad[0] || "",
                    quadEnd: quad[1] || ""
                }
                dls = this.initialState().dls
                displayed = this.NTS
            }
            else {
                // dls
                township = township || ["", ""]
                range = range || ["", ""]
                meridian = meridian || ["", ""]

                dls = {
                    type: this.DLS,
                    townshipStart: township[0] || "",
                    townshipEnd: township[1] || "",
                    rangeStart: range[0] || "",
                    rangeEnd: range[1] || "",
                    meridianStart: meridian[0] || "",
                    meridianEnd: meridian[1] || ""
                }
                nts = this.initialState().nts
                displayed = this.DLS
            }

            this.setState({ displayed, dls, nts }, callback)
        }
        // Else { no params to build the search from }
    }

    reset = (callback) => {
        this.setState(this.initialState(''),
            () => this.setState(this.initialState(), () => callback && callback()))
    }

    handleSelectChange = (type) => {
        return (property) => {
            return (e) => {
                let value = e.target.value ? e.target.value : undefined
                this.setState({ [type]: { ...this.state[type], [property]: value } })
            }
        }
    }
    handleDlsSelectChange = this.handleSelectChange('dls')
    handleNTSSelectChange = this.handleSelectChange('nts')
    handleRadioChange = (e) => this.setState({ displayed: e.target.value })

    render () {
        let content
        if (!this.props.locationOptions) {
            content = <div>Loading Search Location Options...</div>
        }
        else {
            content = this.state.displayed === this.DLS ?
                (
                    <table>
                        <tbody>
                            <CoordinateRange
                                title="Township"
                                name="township"
                                options={this.props.locationOptions.township}
                                data={this.state.dls}
                                handleChange={this.handleDlsSelectChange} />
                            <CoordinateRange
                                title="Range"
                                name="range"
                                options={this.props.locationOptions.range}
                                data={this.state.dls}
                                handleChange={this.handleDlsSelectChange} />
                            <CoordinateRange
                                title="Meridian"
                                name="meridian"
                                options={this.props.locationOptions.meridian}
                                data={this.state.dls}
                                handleChange={this.handleDlsSelectChange} />
                        </tbody>
                    </table>
                ) : (
                    <table>
                        <tbody>
                            <CoordinateRange
                                title="Block"
                                name="block"
                                options={this.props.locationOptions.block}
                                data={this.state.nts}
                                handleChange={this.handleNTSSelectChange} />
                            <CoordinateRange
                                title="Subdivision"
                                name="subdivision"
                                options={this.props.locationOptions.subdivision}
                                data={this.state.nts}
                                handleChange={this.handleNTSSelectChange} />
                            <CoordinateRange
                                title="Map Unit"
                                name="mapUnit"
                                options={this.props.locationOptions.mapUnit}
                                data={this.state.nts}
                                handleChange={this.handleNTSSelectChange} />
                            <CoordinateRange
                                title="Quad"
                                name="quad"
                                options={this.props.locationOptions.quad}
                                data={this.state.nts}
                                handleChange={this.handleNTSSelectChange} />
                        </tbody>
                    </table>
                )
        }

        return (
            <div className="search__location">
                <div className="search__location__radios">
                    <Toggle
                        type="radio"
                        value={this.DLS}
                        checked={this.state.displayed === this.DLS}
                        onChange={this.handleRadioChange}>
                        DLS
                    </Toggle>
                    <Toggle
                        type="radio"
                        value={this.NTS}
                        checked={this.state.displayed === this.NTS}
                        onChange={this.handleRadioChange}
                        className="margin-left">
                        NTS
                    </Toggle>
                </div>
                {content}
            </div>
        )
    }

    componentDidMount() {
        this.props.onRef(this)
    
        graphqlFetch('wcms3', `
            query {
                townships { name }
                ranges { name }
                meridians { name }
                blocks { name }
                subdivisions { name }
                mapunits { name }
                quads { name }
            }`)
            .then(res => {
                const parse = (prop) => res.data[prop].map(x => x.name)                
                const locationOptions = {
                    township:  parse('townships'),
                    range: parse('ranges'),
                    meridian: parse('meridians'),
                    block: parse('blocks'),
                    subdivision: parse('subdivisions'),
                    mapUnit: parse('mapunits'),
                    quad: parse('quads')
                }

                this.props.setConfiguration({ locationOptions })
            })
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }
}

const mapStateToProps = ({data}) => {
    const locationOptions = 
        (data.configuration && 
        data.configuration.locationOptions) ||
        undefined

    return { locationOptions }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setConfiguration: (configuration) => dispatch(setConfiguration(configuration))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LocationSearch)